$('.coupon-application-form').on("submit", function (e) {
    e.preventDefault();

    var el_form = $(this),
        el_button = el_form.find("button[type=submit]"),
        el_error = el_form.find('.invalid-feedback'),
        coupon_code = el_form.find("input[name=coupon_code]").val();

    if (!el_error.length) {

        el_error = $("<div class='invalid-feedback'></div>").insertAfter(el_form.find('input[name="coupon_code"]'));

    }

    el_error.hide();

    App.prototype.loadingButton(el_button, false);

    $.ajax({
        type: 'POST',
        url: el_form.attr("action"),
        dataType: "json",
        data: el_form.serialize(),
        success: function (response) {

            App.prototype.getCart({
                delivery_type_id: $('input[name$="delivery_type_id"]:checked').val(),
                payment_method_id: $('input[name$="payment_method_id"]:checked').val(),
                installment_amount: $('input[name="installment_amount"]:checked').val(),
                cb: function () {

                    App.prototype.loadingButton(el_button, true);

                    $('.coupon-application-form-fields').addClass("d-none");

                    $('.active-coupon-code').removeClass("d-none");

                    $('.active-coupon-code b').text(coupon_code);

                }
            });

        },
        error: function (error) {

            console.error(error);

            el_error.text(error.responseJSON.error).show();

            App.prototype.loadingButton(el_button, true);

        }
    });
});

$('.cancel-coupon').on("click", function (e) {
    e.preventDefault();

    var el_button = $(this);

    App.prototype.loadingButton(el_button, false);

    $.ajax({
        type: 'GET',
        url: $(this).attr("href"),
        dataType: "json",
        complete: function () {

            App.prototype.getCart({
                delivery_type_id: $('input[name$="delivery_type_id"]:checked').val(),
                payment_method_id: $('input[name$="payment_method_id"]:checked').val(),
                installment_amount: $('input[name="installment_amount"]:checked').val(),
                cb: function () {

                    $('.coupon-application-form-fields').removeClass("d-none");

                    $('.active-coupon-code').addClass("d-none");

                    App.prototype.loadingButton(el_button, true);

                }
            });

        },
    });
});
